import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seatLimit'
})
export class SeatLimitPipe implements PipeTransform {

  transform(seatNum: string): string {
    if (!seatNum) return '';
    const seats = seatNum.split(', ');
    return seats.length > 3 
      ? `${seats.slice(0, 3).join(', ')} +${seats.length - 3}` 
      : seatNum;
  }

}
